import { Location } from "@angular/common";
import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Subject, takeUntil } from "rxjs";

@Component({
  templateUrl: "./page-forbidden.component.html",
})
export class PageForbiddenComponent implements OnInit, OnDestroy {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly location = inject(Location);

  private readonly destroySubject = new Subject<void>();

  ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();
  }

  ngOnInit(): void {
    this.activatedRoute.params.pipe(takeUntil(this.destroySubject)).subscribe((params) => {
      this.location.replaceState(params["targetUrl"]);
    });
  }
}
